<div class="form-wrapper">
  <app-notification-form [notification]="notification" (cancelled)="cancelled()"
                         (saved)="saved()"></app-notification-form>

</div>
